import React from "react";
import { Layout, Space, Typography } from "antd";
import { CloseCircleFilled } from '@ant-design/icons'
import PropTypes from 'prop-types'
const NotFound = (props) => {
    const { Content } = Layout
    const { Title,Text } = Typography
    return(
        <Layout className="layout">
            <Content style={{minHeight: '83vh',display: 'flex',justifyContent: 'center' }}>
                {props.accessDenied ?
                <Space style={{marginTop: '25vh'}} align='center' direction='vertical'>
                    <CloseCircleFilled style={{fontSize: 70,color: 'red'}}/>
                    <Title style={{fontSize: 30}}>Access Denied</Title>
                    <Text>You don't have access to access this page</Text>
                </Space> :
                <Space style={{marginTop: '25vh'}} align='center' direction='vertical'>
                    <Title style={{fontSize: 50}}>404</Title>
                    <Text style={{fontSize: 25, fontWeight: 'bold'}}>Not Found</Text>
                    <Text>The requested page is not found on server</Text>
                </Space>}
            </Content>
        </Layout>
    )
}
NotFound.propTypes = {
    accessDenied: PropTypes.any
}
export default NotFound